// extracted by mini-css-extract-plugin
export default {"containerIcon":"UserBlock_containerIcon__MGDbT","container":"UserBlock_container__h5MzB","containerInfo":"UserBlock_containerInfo__vTkF4","box":"UserBlock_box__H-cHY"};